<template>
  <div>
    <b-modal centered size="md" title="Kllaar.com" hide-footer hide-header v-model="modal" no-close-on-backdrop>
      <div class="target">
        <div class="text-center">

          <img src="@/assets/w_logo_max_b.png" alt="" height="50">

        </div>
        <hr>
        <div class="_option p-4">
          <h5 class="text-center">Marcaste tu CV como privado ¿cuál es el motivo?</h5>

          <div class="row justify-content-md-center">

            <div class="col-md-auto">
              <b-form-group class="my-4">
                <b-form-radio v-model="selectMotivo" name="some-radios" :value="1">Conseguí empleo en Kllaar.com</b-form-radio>
                <b-form-radio v-model="selectMotivo" name="some-radios" :value="2">Conseguí empleo en otro sitio</b-form-radio>
                <b-form-radio v-model="selectMotivo" name="some-radios" :value="3">Otro motivo</b-form-radio>
              </b-form-group>
              <label v-if="selectMotivo === 2">
                ¿Qué sitio?
              </label>
              <b-form-input v-if="selectMotivo === 2"
                            id="otro_sitio"
                            v-model="form.motivo"
                            type="text"
                            required
                            class="shadow-sm"
                            placeholder="Nombre del sitio"
              ></b-form-input>

              <label v-if="selectMotivo === 3">
                Ingresa otro motivo.
              </label>
              <b-form-input v-if="selectMotivo === 3"
                            id="otro_motivo"
                            v-model="form.motivo"
                            type="text"
                            required
                            class="shadow-sm"
                            placeholder="Ej. Ya no me gusto"
              ></b-form-input>
            </div>

          </div>



        </div>
        <div class="_buttons mb-3 text-center">
          <b-button type="submit" class="b-orange px-5" :disabled="loading" @click="saveMotivo">
            <b-spinner v-if="loading" small label="Espere ..." ></b-spinner>
            Guardar
          </b-button>
          <button class="btn b-gray-lights px-5" @click="cerrarModal">Cancelar</button>
        </div>
        <div class="text-center">

          <small class="font-gray-dark">*Esta información es confidencial,
            sólo se emplea para cuestiones de estadísticas.</small>

        </div>
      </div>
    </b-modal>

    <b-modal centered size="lg" title="Bienvenido a Kllaar" hide-footer hide-header v-model="modalFilePreview">
      <div class="target text-center">
        <div class="row">
          <div class="col-lg-8">
            <b-img v-if="filePreview" :src="filePreview" fluid alt="Responsive image"></b-img>
            <div class="_fileNoImage align-items-center" v-if="!filePreview">
              <h1 class="far fa-file"></h1>
              <br>
              <h5>No hay vista previa para este archivo</h5>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <div class="row my-3" v-if="controls && !downloading">
      <div class="col-lg-12">
        <div class="_tools align-items-center">
          <button class="btn b-orange shadow-lg" @click="print"><i class="far fa-arrow-alt-circle-down"></i> Exportar</button>
          <router-link to="/perfil/mi-cv" class="btn b-transparent"><i class="fas fa-pen"></i> Editar Mi CV</router-link>
          <div class="_tool-public text-right">
            <b-form-checkbox v-model="user_public" @change="onChangePublic" name="check-button"  class="mx-3" switch>CV Público</b-form-checkbox>
          </div>
        </div>
      </div>
    </div>

    <div class="target-downloading text-center p-1 font-gray-dark"  v-if="downloading">
      <b-spinner small label="Espere ..."></b-spinner>
      <span class="p-1">Espere un momento...</span>
    </div>
      <div class="target b-white rounded shadow-sm py-5" ref="document" v-if="!downloading">
        <div class="text-center">

          <b-button v-if="user.validate_cv_status == 1 && user.education && user.education.length > 0 && user.experience && user.experience.length > 0 && user.software && user.software.length > 0"
            class="btn b-blue" v-b-modal.modal-1>
           Enviar a revisión el contenido de mi CV
          </b-button>

          <b-button v-if="user.validate_cv_status == 3" class="btn b-blue" v-b-modal.modal-1>
            Reenviar a revisión el contenido de mi CV
          </b-button>

          <div v-else-if="user.validate_cv_status == 2">
            <b-button v-if="user.validate_cv_status == 2 && print == 0" disabled class="btn b-blue" v-b-modal.modal-1 >
              <i class="far fa-clock"></i> Validación de CV en proceso
            </b-button>
            <br><br>
            <small class="mt-4">
              Estamos validando la infomación de tu CV. <br>
              Te notificaremos cuando haya finalizado.
            </small>
          </div>

          <b-modal v-model="modalValidation" id="modal-1" class="mt-5" size="lg" centered title="Enviar a Kllaar mi CV para revisión">
            <div class="p-5 ">
              <h3 class="font-orange">Revisar contenido de mi CV</h3>
              <p>
                Con la finalidad de darte mejores ofertas de empleo, puedes solicitar que validemos
                la información que añadiste a tu CV (incluyendo evidencias). Esto te ayudará a
                destacar y tener más oportunidades de encontrar empleo.
              </p>
            </div>
            <template v-slot:modal-footer>
              <div class="w-100">
                <b-button
                    size="md"
                    class="float-right ml-3 b-blue"
                    @click="solicitarValidacion">
                  Solicitar revisión
                </b-button>
                <b-button
                    size="md"
                    class="float-right ml-3 btn-secondary"
                    @click="modalValidation=false">
                  Cancelar
                </b-button>
              </div>
            </template>

          </b-modal>
        </div>

        <div :class="printVal == 0 ? 'container py-5' : 'container'" id="element-to-convert">
          <div class="row">
            <div class="col-lg-4">
              <div class="_header ">
                <img  src="@/assets/tira_azul.jpg" alt="" width="300">
                <div class="_profile">
                  <br> 
                  <center v-if="user.avatar64"><img :src="user.avatar64" alt="" :class="isMobile ? 'shadow-lg rounded-circle' : 'shadow-lg rounded-circle ml-5'" width="120" height="120"></center> 
                  <center v-else><img src="@/assets/profile/user_empty.png" alt="" :class="isMobile ? 'shadow-lg rounded-circle' : 'shadow-lg rounded-circle ml-5'" width="120" height="120"></center> 
                  <br>
                  <div  :class="isMobile ? '_name my-2 text-center' : '_name my-2 text-center ml-5'">
                    <h5 class="m-0 " style="color: #000; text-transform: uppercase;"> 
                        {{user.name + ' ' + user.lname}}
                    </h5>
                    <span  style="color: #000; font-size:10px; text-transform: uppercase;">{{user.education.length > 0 ? user.education[0].titulo : ''}}</span>
                  </div> 
                  <center>
                  <br><br>
                  <div :class="isMobile ? '_color1' : '_color1 ml-4'" :style="isMobile ? 'width: 80%; margin-top: -1vw; border-radius: 15px;' : 'width: 90%; margin-top: -1vw; border-radius: 15px;'" v-if="user.skill && user.skill.length > 0 || printVal == 0">
                    <br>
                    <h6 class="text-center " style="color: #fff;"><i class="fas fa-brain"></i>  <span style="color: #fff;">HABILIDADES</span></h6> 
                  </div>
                  </center>
                  <div class="_color1 container-fluid" :style="isMobile ? 'width: 100%; margin-top: -10vw;' : 'width: 112%; margin-top: -2vw;'" v-if="user.skill && user.skill.length > 0 || printVal == 0"> 
                    <br><br>
                    <div class="_skill ml-2 my-3" v-if="user.skill && user.skill.length > 0"> 
                      <div class="row" v-for="(item, key) in user.skill" :key="key" style="color: #fff;">
                        <div class="col-md-10 text-left ">
                          {{item.habilidad}} 
                        </div> 
                        <div class="col-md-10 mt-4 text-left">
                          <templete v-if="item.file">
                          <b>EVIDENCIA</b>
                          <br> 
                            <a class="text-white" target="_blank" :href="item.file">
                              <i class="fas fa-paperclip font-icon-cv"></i>
                              Descargar
                            </a> 
                          <br><br>
                          </templete>
                          <br>
                        </div>
                      </div> 
                      <br>
                    </div>
                    <div v-else>
                      <br>
                       No hay información capturada
                       <br><br><br><br><br> 
                    </div>
                  </div>
                  <center>
                    <br>
                    <div :class="isMobile ? '_color2' : '_color2 ml-4'" :style="isMobile ? 'width: 80%; margin-top: -16vw; border-radius: 15px;' : 'width: 90%; margin-top: -3.5vw; border-radius: 15px;'" v-if="user.software && user.software.length > 0 || printVal == 0">
                      <br>
                      <h6 class="text-center " style="color: #fff;"><i class="fas fa-desktop"></i> <span style="color: #fff;">SOFTWARE</span></h6> 
                    </div>
                  </center>
                  <div class="_color2 container-fluid" :style="isMobile ? 'width: 100%; margin-top: -10vw;' : 'width: 112%; margin-top: -2.5vw; '" v-if="user.software && user.software.length > 0 || printVal == 0"> 
                    <br><br>
                    <!-- <h5 class="text-center" style="color: #fff;"><i class="fas fa-desktop"></i> SOFTWARE</h5>  -->
                    <div  class="_software  ml-2 my-3" v-if="user.software && user.software.length > 0"> 
                      <div class="row" v-for="(item, key) in user.software" :key="key" style="color: #fff;">
                        <div class="col-md-10 text-left">
                          {{item.software}} 
                        </div> 
                        <div class="col-md-10 mt-4 text-left">
                          <templete v-if="item.file">
                          <b>EVIDENCIA</b> <br> 
                            <a class="text-white" target="_blank" :href="item.file">
                              <i class="fas fa-paperclip font-icon-cv"></i>
                              Descargar
                            </a>
                            <br><br>
                          </templete>
                          <br><br>
                        </div>
                      </div> 
                      <br>
                    </div>
                    <div v-else>
                      <br>
                       No hay información capturada
                       <br><br><br><br><br> <br>
                    </div>
                  </div>
                  <center>
                    <br>
                    <div :class="isMobile ? '_color3' : '_color3 ml-4'" :style="isMobile ? 'width: 80%; margin-top: -16vw; border-radius: 15px;' : 'width: 90%; margin-top: -4.7vw; border-radius: 15px;'" v-if="user.achievement && user.achievement.length > 0 || printVal == 0">
                      <br>
                      <h6 class="text-center " style="color: #fff;"><i class="fas fa-trophy"></i> <span style="color: #fff;">LOGROS Y RECONOCIMIENTOS</span></h6> 
                    </div>
                  </center>
                  <div class="_color3 container-fluid" :style="isMobile ? 'width: 100%; margin-top: -10vw;' : 'width: 112%; margin-top: -3.5vw;'" v-if="user.achievement && user.achievement.length > 0 || printVal == 0"> 
                    <br><br>
                    <!-- <h5 class="text-center" style="color: #fff;"><i class="fas fa-trophy"></i> LOGROS Y RECONOCIMIENTOS</h5> -->
                    <div class="_achievement  ml-2 my-3" v-if="user.achievement && user.achievement.length > 0"> 
                      <div class="row" v-for="(item, key) in user.achievement" :key="key" style="color: #fff;">
                        <div class="col-md-10 text-left">
                          {{item.nombre}} <br>  
                        {{item.tipo}} <br>
                          {{item.mes + ' - ' + item.ano_fin}} <br>
                          <div class="testClass">{{item.descripcion}} </div>
                        </div>   
                        <div class="col-md-10 mt-4  text-left">
                          <templete v-if="item.file">
                          <b>EVIDENCIA</b>
                          <br> 
                            <a class="text-white" target="_blank" :href="item.file">
                              <i class="fas fa-paperclip font-icon-cv"></i>
                              Descargar
                            </a>
                            <br><br>
                          </templete>
                          <br>
                        </div>
                      </div> 
                      <br>
                    </div> 
                    <div v-else>
                      <br>
                       No hay información capturada
                       <br><br><br><br><br> 
                    </div>
                  </div>
                  <center>
                    <br>
                    <div  :class="isMobile ? '_color4' : '_color4 ml-4'" :style="isMobile ? 'width: 80%; margin-top: -16vw; border-radius: 15px;' : 'width: 90%; margin-top: -3.5vw; border-radius: 15px;'" v-if="user.student_info && user.student_info.location || printVal == 0">
                      <br>
                      <h6 class="text-center " style="color: #fff;"><i class="fas fa-address-book"></i> <span style="color: #fff;">CONTACTO</span></h6> 
                    </div>
                  </center>
                  <div  class="_color4 container-fluid" :style="isMobile ? 'width: 100%; margin-top: -10vw; color: #fff;' : 'width: 112%; margin-top: -2.5vw; color: #fff;'"  v-if="user.student_info && user.student_info.location || printVal == 0"> 
                    <div v-if="user.student_info && user.student_info.location">
                    <br><br>
                    <!-- <h5 class="text-center" style="color: #fff;"><i class="fas fa-address-book"></i> CONTACTO</h5> -->
                    <div class="_location ml-2 my-3" v-if="user.student_info && user.student_info.location">
                      <div class="row"> 
                        <div class="col-md-10">{{user.student_info.location}}</div>
                      </div> 
                    </div> 
                    <div class="_phone ml-2 my-2" v-if="user.student_info && user.student_info.phone">
                      <div class="row"> 
                        <div class="col-md-10"><b>Teléfono</b> <br>{{user.student_info.phone}}</div>
                      </div>
                    </div> 
                    <div class="_birtday ml-2 my-2" v-if="user.student_info && user.student_info.birthday">
                      <div class="row"> 
                        <div class="col-md-10"><b>Cumpleaños</b> <br> {{user.student_info.birthday}} <br><br></div>
                      </div> 
                    </div>  
                  </div> 
                  <div v-else>
                    <br><br><br>
                      No hay información capturada
                      <br><br><br> 
                  </div>
                 </div>
                </div>
              </div>
            </div> 
            <div class="col-lg-8">
              <template  v-if="user.student_info && user.student_info.biography || printVal == 0">
                <img  src="@/assets/biografia.jpg" alt="" class=" img-fluid" > 
                <br><br>  
                <div class="row">
                  <div class="_biography col" v-if="user.student_info && user.student_info.biography">
                    <br>
                    <!-- <h4 class="text-kllaar"><i class="fa fa-address-card font-icon-cv" aria-hidden="true"></i> Biografía</h4> -->
                    <p class="text-justify">{{user.student_info.biography}}</p>
                    <br> 
                  </div>
                  <div v-else>
                    <br> 
                      <span class="ml-4">No hay información capturada</span>
                      <br><br><br> 
                  </div>
                </div>
              </template>
              <template  v-if="user.education && user.education.length > 0 || printVal == 0">
                <img  src="@/assets/educacion.jpg" alt="" class=" img-fluid" > 
                <br><br>
                <div class="_education my-3" v-if="user.education && user.education.length > 0"> 
                  <div class="row" v-for="(item, key) in user.education" :key="key">
                    <div class="col-md-10 ml-4 text-left">
                      <b>{{item.ano_inicio + ' - ' + item.ano_fin}}</b>
                      <br>
                      {{item.titulo}} - {{item.grado}}
                    </div>
                    <div class="col-md-10 text-left mt-4 ml-4">
                      <b>INSTITUTO</b>
                      <br>
                      {{item.institucion}}
                    </div>
                    <div class="col-md-10 text-left mt-4 ml-4">
                       <templete v-if="item.file">
                      <b>EVIDENCIA</b>
                      <br> 
                        <a class="text-kllaar" target="_blank" :href="item.file">
                          <i class="fas fa-paperclip font-icon-cv"></i>
                          Descargar
                        </a>
                      </templete>
                      <br> <br>
                    </div>
                  </div> 
                </div>
                <div v-else>
                  <br> 
                    <span class="ml-4">No hay información capturada</span>
                    <br><br><br> 
                </div>
              </template>
              <template  v-if="user.experience && user.experience.length > 0 || printVal == 0">
                  <img  src="@/assets/experiencia.jpg" alt="" class="shadow-lg img-fluid" > 
                  <br><br>
                    <div class="_experience my-3" v-if="user.experience && user.experience.length > 0"> 
                      <div class="row"  v-for="(item, key) in user.experience" :key="key" >
                        <div class="col-md-10 text-left ml-4"> 
                          <b>{{item.ano_inicio + ' - '}} <span v-if="item.ano_fin == null">Actualidad</span><span v-else>{{item.ano_fin}}</span></b>
                          <br>
                          <b><em>{{item.puesto}}</em></b>
                          <br>
                          {{item.empresa}} <br>
                          {{item.area}} 
                        </div>  
                        <div class="col-md-10 mt-4 text-left ml-4">
                          <b>ACTIVIDADES</b>
                          <br>
                          <div class="testClass">{{item.descripcion}}</div>
                          <br> 
                        </div>
                      </div> 
                    </div>
                    <div v-else>
                      <br> 
                        <span class="ml-4">No hay información capturada</span>
                        <br><br><br> 
                    </div>
                </template>
                <template  v-if="user.project && user.project.length > 0 || printVal == 0">
                  <img  src="@/assets/proyectos.jpg" alt="" class="shadow-lg img-fluid"  > 
                  <br> <br>
                 <template v-if="user.project && user.project.length > 0"> 
                    <div class="_project my-3" > 
                      <div class="row"  v-for="(item, key) in user.project" :key="key" >
                        <div class="col-md-10 text-left ml-4"> 
                          <b>{{item.nombre}}</b>
                          <br>
                          {{item.tipo}}
                        </div>   
                        <div class="col-md-10 mt-4 text-left ml-4">
                          <templete v-if="item.file">
                          <b>EVIDENCIA</b>
                          <br> 
                            <a class="text-kllaar" target="_blank" :href="item.file">
                              <i class="fas fa-paperclip font-icon-cv"></i>
                              Descargar
                            </a>
                          </templete>
                          <br>  <br>
                        </div>
                      </div> 
                    </div> 
                </template>
                <div v-else>
                  <br> 
                    <span class="ml-4">No hay información capturada</span>
                    <br><br><br> 
                </div>
              </template>
              <template  v-if="user.service && user.service.length > 0 || printVal == 0">
                  <img  src="@/assets/servicio.jpg" alt="" class="shadow-lg img-fluid" > 
                  <br> <br>
                  <div class="_service" v-if="user.service && user.service.length > 0"> 
                    <div class="row"   v-for="(item, key) in user.service" :key="key" >
                      <div class="col-md-10 text-left ml-4"> 
                        <b>{{item.funcion_desempenada}}</b>
                        <br>
                        {{item.ano_inicio + ' - ' + (!item.ano_fin ? 'Aun en curso' : item.ano_fin)}} <br>
                      <div class="testClass"> {{item.descripcion}}</div>
                      </div>   
                      <div class="col-md-10 mt-4 text-left ml-4">
                        <templete v-if="item.file">
                        <b>EVIDENCIA</b>
                        <br><br>
                          <a class="text-kllaar" target="_blank" :href="item.file">
                            <i class="fas fa-paperclip font-icon-cv"></i>
                            Descargar
                          </a>
                        </templete>
                        <br><br>
                      </div>
                    </div> 
                  </div> 
                  <div v-else>
                    <br> 
                    <span class="ml-4">No hay información capturada</span>
                      <br><br><br> 
                  </div> 
              </template>
            </div>
          </div>  
        </div>
      </div>

  </div>
</template>
<script>
// import { htmlToPaper } from 'vue-html-to-paper'
// import VueHtml2pdf from 'vue-html2pdf'
import html2pdf from "html2pdf.js";
export default { 
  // components: {
  //     VueHtml2pdf
  // },
  props:{
    controls: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isMobile: this.$mobile(), 
      modalValidation: false,
      loading: false,
      modal: false,
      modalFilePreview: false,
      filePreview: null,
      fileDownload: null,
      motivos: [{ text: 'Selecciona una opción', value: null }, 'Conseguí empleo en Kllaar.com', 'Conseguí empleo en otro sitio', 'Otro motivo'],
      selectMotivo:1,
      form:{
        motivo: ''
      },
      downloading: false,
      user: {},
      user_public:false,
      printVal:0
    }
  },
  mounted() {
    this.downloading = true
    this.api.get('student/info/userinfocv').then(({data}) => { //Obtener toda la información de usuario y enviarla a los componentes
      this.user = data.data
      this.user_public = data.data.public
      this.downloading = false
    }).catch(err => {})
  },
  methods: {
    exportToPDF() {
      html2pdf(document.getElementById("element-to-convert"), {
				margin: 1,
  			filename: "CV.pdf",
			});
    },
    cerrarModal(){
      this.modal = false
      this.user_public = true
    },
    openFile(file){
      this.fileDownload = file
      let ext = file.substr(file.lastIndexOf('.') + 1);
      if(ext == 'png' || ext == 'jpg' || ext == 'jpeg' || ext == 'gif'){
        this.filePreview = file
      }else{
        this.filePreview = null
      }

      this.modalFilePreview = true

    },
    print () { 
      this.printVal = 1;
      this.exportToPDF();
      // this.$refs.html2Pdf.generatePdf() 
      // this.$refs.html2pdf(element, {
      //     enableLinks: true 
      // });
      setTimeout(() => {
        this.printVal = 0;
      }, 600)
    },
    // print() {
    //   this.$htmlToPaper('printMe');
    // },
    onChangePublic(status){

      if(!status){
        this.modal = true
        return !status
      }

      this.api.get('student/cv/public/true').then(({data}) => {
        this.loading = false
        this.toast(data.data.message)
        this.user_public = true
      }).catch(err => {
		  if(err.response.status === 500){
			  this.toast(err.response.data.errors.general, 'danger')
		  }
	  })

    },
    saveMotivo(){

      let reason = 'Conseguí empleo en Kllaar.com'

      if (this.selectMotivo===2){
        reason =`Conseguí empleo en otro sitio: ${this.form.motivo}`
      }else if (this.selectMotivo===3){
        reason =`Otro motivo: ${this.form.motivo}`
      }

      if (this.selectMotivo == 2 && !this.form.motivo)
      {
         swal("Validación", "Nombre del sitio requerido", "warning")
      }else if(this.selectMotivo == 3 && !this.form.motivo){
        swal("Validación", "Motivo requerido", "warning")
      }else{

          this.api.post('student/cv/reason',{public: false, reason: reason}).then(({data}) => {
            this.loading = false
            this.form.motivo = ''
            this.selectMotivo = 1
            this.toast(data.data.message)
            this.user_public = false
          }).catch(err => {
            if(err.response.status === 500){
          this.toast(err.response.data.errors.general, 'danger')
        }
        })

          this.modal = false
      }
    },
    toast(message, variant = 'success'){
      this.$bvToast.toast(message, {
        title: "Kllaar.com",
        variant: variant,
        toaster: 'b-toaster-bottom-right',
        solid: true,
        appendToast: true
      })
    },
    solicitarValidacion() {
      this.api.post('student/cv/request-validation').then(({data}) => {
        this.modalValidation = false;
        this.user.validate_cv_status = 2;
        this.toast(data.data.message)
      }).catch(err => {
        if (err.response.status === 500){
			console.log(err.response)
			this.toast(err.response.data.errors.general, 'danger')
		}
        this.modalValidation = false;
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.font-icon-cv{
  color: #f9c332;
}

._color1{
 background: #29c5ee;
 border-color: #29c5ee;
 color: #fff;
}

._color2{
 background: #0d8fc9;
 border-color: #0d8fc9;
  color: #fff;
}

._color3{
 background: #105982;
 border-color: #105982;
  color: #fff;
}

._color4{
 background: #09405e;
 border-color: #09405e;
  color: #fff;
}

._profile{
  color: #fff;
}

@media screen and (max-width: 791px) {
  #right, #left {
    text-align: center !important;
  }
}


.testClass{
   white-space: -moz-pre-wrap; /* Mozilla, supported since 1999 */
    white-space: -pre-wrap; /* Opera */
    white-space: -o-pre-wrap; /* Opera */
    white-space: pre-wrap; /* CSS3 - Text module (Candidate Recommendation) http://www.w3.org/TR/css3-text/#white-space */
    word-wrap: break-word; /* IE 5.5+ */
}
</style>



// WEBPACK FOOTER //
// src/components/#pages/profile/page/Curriculum.vue